/** @format */

import { post, download } from '@root/utils/httpWrap';

/**
 *
 * @param params
 */
export const queryMonthCardPaymentList = (params: any): any => {
  return post('/bangdao/saasapi/v1/monthCardPayment/list', params);
};

/**
 * 车辆变更记录
 * @param params
 */
export const queryCardPlateRecordList = (params: any): any => {
  return post('/bangdao/saasapi/v1/cardPlateRecord/list', params);
};

/**
 * 提交车辆变更
 * @param params
 */
export const commitModifyCar = (params: any): any => {
  return post('/bangdao/saasapi/v1/monthCard/plate', params);
};

/**
 * 长租在线签约管理列表
 */

export const queryMonthCardApplyList = (params: any): any => {
  return post('/bangdao/saasapi/v1/monthCardApply/list', params);
};

/**
 * 长租在线签约管理详情
 */

export const queryMonthCardApplyDetail = (params: any): any => {
  return post('/bangdao/saasapi/v1/monthCardApply/detail', params);
};

/**
 * 长租在线签约管理审核
 */

export const queryMonthCardApplyReview = (params: any): any => {
  return post('/bangdao/saasapi/v1/monthCardApply/review', params);
};

/**
 * 根据车场查询车场对应类型套餐-车场单选
 */
export const querySpacePackageSelectList = (params: any): any => {
  return post('/bangdao/saasapi/v1/spacePackage/selectList', params);
};

/**
 * 根据车场查询车场对应类型套餐-车场多选
 */
export const spacePackageSelectLists = (params: any): any => {
  return post('/bangdao/saasapi/v1/spacePackage/selectLists', params);
};

/**
 * 月卡套餐查询车位列表
 * /bangdao/saasapi/v1/space/selectList
 */

export const querySpaceSelectList = (params: any): any => {
  return post('/bangdao/saasapi/v1/space/selectList', params);
};

/**
 * 计算费用或结束日期
 */

export const queryMonthCardCacuteTime = (params: any): any => {
  return post('/bangdao/saasapi/v1/monthCard/cacuteTime', params);
};
/**
 * //bangdao/saasapi/v1/monthCard/buy  办理月卡
 */

export const queryMonthCardBuy = (params: any): any => {
  return post('/bangdao/saasapi/v1/monthCard/buy', params);
};

/**
 * 月卡列表
 */
export const queryMonthCardList = (params: any): any => {
  return post('/bangdao/saasapi/v1/monthCard/list', params);
};

/**
 * 停租
 */

export const queryMonthCardStop = (params: any): any => {
  return post('/bangdao/saasapi/v1/monthCard/stop', params);
};
/**
 * 退费
 * @param params
 */

export const quertMonthCardRefund = (params: any): any => {
  return post('/bangdao/saasapi/v1/monthCard/refund', params);
};
/**
 * 作废
 * @param params
 */

export const quertcancel = (params: any): any => {
  return post('/bangdao/saasapi/v1/monthCardPayment/cancel', params);
};
/**
 * 银行开户行级联菜单
 * @param params
 */

export const querydownMenu = (params: any): any => {
  return post('/bangdao/saasapi/v1/baseBank/downMenu', params);
};
/**
 * 退费金额计算（长城定制)
 * @param params
 */

export const refundMenu = (params: any): any => {
  return post('/bangdao/saasapi/v1/monthCard/refundPrice', params);
};

// 冻结解冻
/**
 * 冻结解冻详情
 * @param params
 */

export const detailMenu = (params: any): any => {
  return post('bangdao/saasapi/v1/monthCard/freeze/detail', params);
};
/**
 * 冻结
 * @param params
 */

export const freezeMenu = (params: any): any => {
  return post('/bangdao/saasapi/v1/monthCard/freeze', params);
};
/**
 * 解冻
 * @param params
 */

export const unfreezeMenu = (params: any): any => {
  return post('/bangdao/saasapi/v1/monthCard/unfreeze', params);
};
/**
 * 详情
 * @param params
 */
export const quertMonthCardDetail = (params: any): any => {
  return post('/bangdao/saasapi/v1/monthCard/detail', params);
};

/**
 * 套餐下拉
 * @param params
 */
export const selectRenewPackageList = (params: any): any => {
  return post('/bangdao/saasapi/v1/spacePackage/selectRenewPackageList', params);
};

/**
 * 续费
 * @param params
 */

export const quertMonthCardRenew = (params: any): any => {
  return post('/bangdao/saasapi/v1/monthCard/renew', params);
};

/**
 * 月度分摊报表列表
 */
export const monthCardReportList = (params: any): any => {
  return post('/bangdao/saasapi/v1/eas/monthCardReportList', params);
};

/**
 * 月度分摊报表 导出
 */
export const exportMonthCardReport = (params: any, fileName: string | undefined): any => {
  return download('/bangdao/saasapi/v1/eas/exportMonthCardReport', params, fileName);
};

export const exportPropertyExcelExport = (params: any, fileName?: string): any => {
  return download('bangdao/saasapi/v1/monthCard/propertyExcelExport', params, fileName);
  // return download('bangdao/saasapi/v1/monthCard/propertyExcelExport', transformParam(params), fileName)
};

export const exportMonthExcelExport = (params: any, fileName?: string): any => {
  return download('bangdao/saasapi/v1/monthCard/monthExcelExport', params, fileName);
};
/**
 * 产权、长租 下载模板
 */
export const downloadTemplate = (params?: any, fileName?: string): any => {
  return download('/bangdao/saasapi/v1/monthCard/template', params, fileName);
};

/**
 * 产权失败数据下载模板
 */
export const downloadpropertyErrorExcelExport = (params?: any, fileName?: string): any => {
  return download('/bangdao/saasapi/v1/monthCard/propertyErrorExcelExport', params, fileName);
};

/**
 * 月卡失败数据下载模板
 */
export const downloadlongrentErrorExcelExport = (params?: any, fileName?: string): any => {
  return download('/bangdao/saasapi/v1/monthCard/longrentErrorExcelExport', params, fileName);
};

/**
 * 固定车辆交易记录导出
 * @param params
 */
export const monthCardPaymentExcelExport = (params: any, fileName?: string): any => {
  return download('/bangdao/saasapi/v1/monthCardPayment/monthCardPaymentExcelExport', params, fileName);
};
/**
 * 根据车场获取车场所在地默认车牌
 * @param params
 */
export const getPlate = (params: any): any => {
  return post('bangdao/saasapi/v1/basePark/plate', params);
};
/**
 * 车辆变更删除时，校验是否是在场车辆
 * @param params
 */
export const orderEnterPlate = (params: any): any => {
  return post('bangdao/saasapi/v1/orderEnter/plate', params);
};
/**
 * 是否启用优先车辆
 * @param params
 */
export const masterSlave = (params: any): any => {
  return post('bangdao/saasapi/v1/baseUniformRule/masterSlave', params);
};
// /bangdao/saasapi/v1/monthCard/checkOut
/**
 * 是否校验是否存在其他月卡车
 * @param params
 */
export const monthCardCheckOut = (params: any): any => {
  return post('bangdao/saasapi/v1/monthCard/checkOut', params);
};

/**
 * 储值卡下载模板
 */
export const storedtemplate = (params?: any, fileName?: string): any => {
  return download('/bangdao/saasapi/v1/storedCard/template', params, fileName);
};

/**
 * 储值卡导出失败数据
 */
export const errorExcelExport = (params?: any, fileName?: string): any => {
  return download('/bangdao/saasapi/v1/storedCard/errorExcelExport', params, fileName);
};

/**
 * 储值卡业务办理导出
 */
export const stoExcelExport = (params?: any, fileName?: string): any => {
  return download('/bangdao/saasapi/v1/storedCard/export', params, fileName);
};
/**
 * 储值卡消费记录导出
 */
export const storedCardPaymentExport = (params?: any, fileName?: string): any => {
  return download('/bangdao/saasapi/v1/storedCardPayment/export', params, fileName);
};
/**
 * 储值卡缴费记录导出
 */
export const storedCardRecordExport = (params?: any, fileName?: string): any => {
  return download('/bangdao/saasapi/v1/storedCardRecord/export', params, fileName);
};
/**
 * 批量退费校验接口
 */
export const monthCardCheck = (params: any): any => {
  return post('/bangdao/saasapi/v1/monthCard/check', params);
};
/**
 * 批量退费接口
 */
export const refundByList = (params: any): any => {
  return post('/bangdao/saasapi/v1/monthCard/refundByList', params);
};

/**
 * 备注修改
 */
export const editRemark = (params: any): any => {
  return post('/bangdao/saasapi/v1/monthCard/editRemark', params);
};
/**
 * 车位池-车场名称
 */
export const merchantSpacePoolGetPark = (params: any): any => {
  return post('/bangdao/saasapi/v1/merchantSpacePool/getPark', params);
};
/**
 * 车位池-新办月卡
 */
export const merchantSpacePoolBuy = (params: any): any => {
  return post('bangdao/saasapi/v1/merchantSpacePool/buy', params);
};
/**
 * 短信推送模板列表
 */
export const getSmsTemplate = (params: any): any => {
  return post('/bangdao/saasapi/v1/helpself/tentcentSms/getSmsTemplate', params);
};
/**
 * 短信推送
 */
export const monthCardSendSms = (params: any): any => {
  return post('/bangdao/saasapi/v1/monthCard/sendSms', params);
};
/**
 * 短信推送催缴记录
 */
export const monthCardsmsRecord = (params: any): any => {
  return post('/bangdao/saasapi/v1/monthCard/smsRecord', params);
};
/**
 * 短信推送催缴导出
 */
export const exportSmsRecord = (params?: any, fileName?: string): any => {
  return download('/bangdao/saasapi/v1/monthCard/exportSmsRecord', params, fileName);
};
/**
 * 取消订单
 */
export const cancelOrder = (params: any): any => {
  return post('/bangdao/saasapi/v1/monthCardApply/cancelOrder', params);
};

/**
 * 详情
 * @param params
 */
export const getEditUser = (params: any): any => {
  return post('/bangdao/saasapi/v1/monthCard/editUser', params);
};
/**
 * 查询车场关联的所有管理区
 */
export const selectCommunty = (params: any): any => {
  return post('/bangdao/saasapi/v1/monthCard/selectCommunty', params);
};
/**
 * 查询管理区关联的所有楼栋
 */
export const selectBuild = (params: any): any => {
  return post('/bangdao/saasapi/v1/monthCard/selectBuild', params);
};
/**
 * 查询房间列表
 */
export const selectRoom = (params: any): any => {
  return post('/bangdao/saasapi/v1/monthCard/selectRoom', params);
};
/**
 * 下发轨迹
 */
export const sendProcess = (params: any): any => {
  return post('/bangdao/saasapi/v1/sendMessage/sendProcess', params);
};
/**
 * 重新下发
 */
export const sendAgain = (params: any): any => {
  return post('/bangdao/saasapi/v1/sendMessage/sendAgain', params);
};
